var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDropSm2(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9.696,
    height: 5.77,
    viewBox: "0 0 9.696 5.77",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "arrow_drop_down_FILL0_wght400_GRAD0_opsz48",
    d: "M327.084,502.492l-3.919-3.919a.856.856,0,0,1-.2-1,.845.845,0,0,1,.849-.571h7.837a.845.845,0,0,1,.849.571.856.856,0,0,1-.2,1l-3.919,3.919a.941.941,0,0,1-.309.216.965.965,0,0,1-.679,0A.941.941,0,0,1,327.084,502.492Z",
    transform: "translate(-322.884 -497)",
    fill: "#a9acbb"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropSm2);
export default __webpack_public_path__ + "static/media/drop-sm-2.44d45bdccd70d628b3576fbcb7034b4d.svg";
export { ForwardRef as ReactComponent };